/**
 * BFS / Polaris feedback SSOT.
 *
 * @see https://shopify.dev/docs/apps/launch/built-for-shopify/requirements §4.2.4 · 4.3.3 · 4.3.4
 * @see SafeGeo_UI_UX_Final_v1.4 §F
 *
 * | Kind        | Component                         | Notes                          |
 * |-------------|-----------------------------------|--------------------------------|
 * | Page error  | `PageBanner` tone=critical        | Persistent - never toast (BFS) |
 * | Field error | `s-text-field error=`             | Next to the field              |
 * | Warning     | `PageBanner` tone=warning         | Max 1 page banner              |
 * | Info        | `PageBanner` tone=info            | Guidance, not failure          |
 * | Success     | `showToast` (preferred) or banner | Toast OK for short confirms    |
 * | Loading     | `PageLoading` / `s-spinner`       | Keep section height stable     |
 * | Empty       | `EmptyState`                      | One CTA                        |
 * | Upsell      | `PageBanner` dismissible          | Or UnlockModals (BFS 4.3.6)    |
 */

export type BannerTone = "info" | "success" | "warning" | "critical";

/** Prefer toast for short success confirms - never for errors (BFS 4.2.4). */
export function showToast(
  message: string,
  opts?: { isError?: boolean; duration?: number },
): void {
  if (opts?.isError) {
    // Errors must stay on-page; refuse toast path.
    console.warn(
      "[SafeGeo] Do not toast errors (BFS 4.2.4). Use PageBanner critical.",
      message,
    );
    return;
  }
  try {
    const shopify = (
      window as Window & {
        shopify?: {
          toast?: {
            show: (
              msg: string,
              o?: { isError?: boolean; duration?: number },
            ) => void;
          };
        };
      }
    ).shopify;
    shopify?.toast?.show(message, {
      duration: opts?.duration ?? 4000,
    });
  } catch {
    /* standalone / missing App Bridge */
  }
}
